import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { isAuthenticated } from '../../../store/selectors/AuthSelectors';
import {
  FiLock,
  FiShield,
  FiUsers,
  FiEye,
  FiClipboard,
  FiKey,
  FiLayers,
  FiClock,
  FiCpu,
  FiGitBranch,
  FiUser,
  FiCheck,
} from 'react-icons/fi';
import { credentialVaultMarketingSixBoxes } from '../../data/credentialVaultMarketingBoxes';
import '../FeaturesSection/FeaturesSection.css';
import './ProductCredentialVaultContent.css';

const ProductCredentialVaultContent = () => {
  const loggedIn = useSelector(isAuthenticated);
  const sixBoxes = credentialVaultMarketingSixBoxes;

  const features = [
    { icon: <FiLock />, text: 'Master key based access to all your credentials. ' },
    { icon: <FiShield />, text: 'Master key is never stored or transmitted through internet.' },
    { icon: <FiUser />, text: 'AES-256-GCM level encryption.' },
    { icon: <FiLayers />, text: 'Two levels of authentication to access the credentials.' },
    { icon: <FiGitBranch />, text: 'Easy sharing and copying from flowdo platform.' },
    { icon: <FiEye />, text: 'Unlimited credential storage.' },
  ];

  return (
    <>
      <section className="product-credential-vault-six-boxes">
        <div className="container">
          <div className="features-grid">
            {sixBoxes.map((box, index) => (
              <div key={index} className="feature-card">
                <h3>{box.title}</h3>
                <p>{box.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="product-credential-vault-features">
        <div className="container">
          <h2 className="product-credential-vault-features-title">Features</h2>
          <ul className="product-credential-vault-features-list">
            {features.map((feature, index) => (
              <li key={index}>
                <span className="product-credential-vault-feature-icon">{feature.icon}</span>
                <span className="text-muted">{feature.text}</span>
              </li>
            ))}
          </ul>
          <div className="section-cta product-credential-vault-features-cta">
            <Link
              to={
                loggedIn
                  ? '/credential-vault/credentialVaultList'
                  : '/register?module=credentialvault'
              }
              className="subscribe-btn"
            >
              Access Credentials Vault for Free
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default ProductCredentialVaultContent;
